<p-toast position="top-right"></p-toast>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <sidebar-existing-rider-vehicle-detail *ngIf="visibleSidebarRiderVehicleDetail"
                                           [_visibleSidebarRiderVehicleDetail]="visibleSidebarRiderVehicleDetail"
                                           [_riderVehicleServiceTypeId]="riderVehicleServiceTypeId"
                                           [_riderVehicleId]="riderVehicleId"
                                           [_riderId]="riderId"
                                           [onboardingVehiclesComponent]="this"
                                           (changedVisibleSidebarRiderVehicleDetailEmit)="changedVisibleSidebarRiderVehicleDetailEmit($event)">
    </sidebar-existing-rider-vehicle-detail>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <div class="onboarding-body">
            <div class="onboarding-head mb-4">
                <div class="onboarding-head-fleft">
                    <ol class="breadcrumbs-menu">
                        <ng-container *ngFor="let item of tabMenu">
                            <li class="breadcrumbs-menu-item"
                                [class]="(item.value === activeMenu) ? 'breadcrumbs-menu-active' : ''"
                                (click)="changeActiveMenu(item.value)">{{item.name}}</li>
                        </ng-container>
                        <!--<li class="breadcrumbs-menu-item"
                            [class]="(activeMenu === wheelsEnum.TwoWheels) ? 'breadcrumbs-menu-active' : ''"
                            (click)="changeActiveMenu(wheelsEnum.TwoWheels)">2 Wheels</li>
                        <li class="breadcrumbs-menu-item"
                            [class]="(activeMenu === wheelsEnum.FourWheels) ? 'breadcrumbs-menu-active' : ''"
                            (click)="changeActiveMenu(wheelsEnum.FourWheels)">4 Wheels</li>-->
                    </ol>
                </div>
                <div class="flex flex-row onboarding-head-right">
                    <div class="onboarding-head-date">
                        <p-calendar [(ngModel)]="riderOnboardingDate" [showIcon]="true" (ngModelChange)="onChangeDateAndDropDown($event)"></p-calendar>
                    </div>
                    <div class="ml-5 mt-2">
                        <column-selector #columnSelector
                             [defaultColumns]="defaultCols"
                             (selectedColumnsChange)="onSelectedColumnsChange($event)"
                             [tableName]="menuPermissionActive"
                             [(selectedColumns)]="cols">
                        </column-selector>
                    </div>
                </div>
            </div>
            <p-table #ridersGrid
                     [columns]="cols"
                     [value]="gridRiders.Items"
                     [lazy]="true"
                     responsiveLayout="scroll" dataKey="Id"
                     (onLazyLoad)="handleLazyLoad($event)"
                     [loading]="gridRiders.Loading"
                     [paginator]="true"
                     [(first)]="first"
                     [rows]="rowsPerPage"
                     [totalRecords]="totalRecords"
                     [resizableColumns]="true"
                     [columnResizeMode]="'expand'"
                     [showFirstLastIcon]="false"
                     [autoLayout]="true"
                     [styleClass]="'p-datatable-gridlines'"
                     [scrollable]="true"
                     [scrollHeight]="'flex'"
                     [style]="{height: 'calc(70vh)'}">
                <ng-template pTemplate="caption">
                    <div class="flex flex-row sp-header">
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngFor="let col of cols"
                            [pSortableColumn]="col.field"
                            [pSortableColumnDisabled]="col.disableSort"
                            pResizableColumn
                            [style.width]="col.width">
                            {{col.header}}
                            <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                        </th>
                    </tr>
                    <tr>
                        <ng-container *ngFor="let filter of cols">
                            <th class="overflow-unset">
                                <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Inputs">
                                    <input type="text" pInputText placeholder="{{filter.placeholder}}" [(ngModel)]="riderHeaderSearch[filter.model]"
                                           (input)="onChangeHeaderFilterDropDown(filter.field, $event)" />
                                </ng-container>
                                <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Dropdown">
                                    <ng-container *ngIf="filter.take === 'obj'; else dropdown">
                                        <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                                    optionLabel="label" [(ngModel)]="riderHeaderSearch[filter.model]"
                                                    (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                    </ng-container>
                                    <ng-template #dropdown>
                                        <p-dropdown [options]="filter.options" placeholder="{{filter.placeholder}}"
                                                    optionLabel="name" optionValue="value" [(ngModel)]="riderHeaderSearch[filter.model]"
                                                    (ngModelChange)="onChangeHeaderFilterDropDown(filter.field, $event)"></p-dropdown>
                                    </ng-template>
                                </ng-container>
                                <ng-container *ngIf="filter.model === 'lastActiveType'">
                                    <p-dropdown [options]="lastActiveTypeList" placeholder="Please Select"
                                                optionLabel="name"
                                                [(ngModel)]="riderHeaderSearch.lastActiveTypeObj"
                                                (ngModelChange)="handleHeaderFilterChange(filter.field, $event)"></p-dropdown>
                                </ng-container>
                                <ng-container *ngIf="filter.fieldType === fieldTypeEnum.Calendar">
                                    <p-calendar [(ngModel)]="riderHeaderSearch[filter.model]"
                                                [showIcon]="true"
                                                placeholder="{{filter.placeholder}}"
                                                [showTime]="true"
                                                dateFormat="dd M yy"
                                                (ngModelChange)="onChangeDateAndDropDown($event)" />
                                </ng-container>
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rider>
                    <tr [pSelectableRow]="rider">
                        <ng-container *ngFor="let col of cols" >
                            <td *ngIf="col.field === 'Status'" class="ui-resizable-column">
                                <span class="onbg-status-col"
                                      [style.background-color]="rider.StatusColor"
                                      (click)="openSidebarExistingVehicleDetail(rider)">{{rider.Status}}</span>
                            </td>
                            <td *ngIf="col.field === 'LastUpdate'" class="ui-resizable-column" [style.color]="rider.LastActiveAtTextColor">
                                {{ rider.LastUpdate }}
                            </td>
                            <td *ngIf="col.field !== 'Status' && col.field !== 'LastUpdate'" class="ui-resizable-column">
                                {{ rider[col.field] }}
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="100%">
                        <div class="flex flex-column align-items-center justify-content-center py-6">
                          <img
                            src="/XpressApp/assets/images/commerce/no-product.png"
                            alt="No data"
                            class="w-40 h-40 mb-3 opacity-70"
                          />
                          <span class="text-gray-500 text-sm">There are no existing Vehicles.</span>
                        </div>
                      </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="paginatorleft" let-state>
                    <div *ngIf="gridRiders.Items !== null && gridRiders.Items.length > 0" style="padding-left: 10px">
                        Showing {{first + 1}} to {{first + gridRiders.Items.length}} of {{totalRecords}} entries
                    </div>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
